export default __webpack_public_path__ + "static/media/3aaec04ae387df5e269c45ad5af213077320d2025a48132c56eb80ab480affb6.407af963.png";